// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"514":"9dfc8055","578":"aa43c9f9","787":"1af3d902","805":"85b8168e","883":"39630f40","974":"bf8f6fe1"}[chunkId] + ".chunk.js";
};